export default __webpack_public_path__ + "static/media/Success.c717ed91.svg";